import { genericRequestNoResponse, get, patch, post } from './fetch';

export const getCustomers = () => {
  return get({ endpoint: 'api/Customer/' });
};

export const getCustomer = (customerId) => {
  return get({ endpoint: `api/Customer/${customerId}/` });
};

export const createCustomer = (customer) => {
  return post({ endpoint: 'api/Customer/', body: customer });
};

export const updateCustomer = (customer) => {
  return patch({ endpoint: `api/Customer/${customer.id}`, body: customer });
};

export const syncCustomers = () => {
  return genericRequestNoResponse({ endpoint: `api/customer/sync` }, 'PATCH');
};